// extracted by mini-css-extract-plugin
export default {"requirement":"ConditionFulfillment_requirement__p8clZ"};